import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SnackBar } from '../../components/SnackBar/SnackBarPopup';
import { AppType, Loading } from '../../enums';

export interface AppState {
    appType: AppType;
    referrer: string;
    language: string;
    loading: Loading | null;
    snackbarMessages: SnackBar[];
}

const initialState: AppState = {
    appType: null as unknown as AppType,
    referrer: '',
    language: '',
    loading: null,
    snackbarMessages: [],
};

export const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        setAppType: (state, action: PayloadAction<AppType>) => {
            state.appType = action.payload;
        },
        setReferrer: (state, action: PayloadAction<string>) => {
            state.referrer = action.payload;
        },
        setLanguage: (state, action: PayloadAction<string>) => {
            state.language = action.payload;
        },
        setLoading: (state, action: PayloadAction<Loading | null>) => {
            state.loading = action.payload;
        },
        enqueueSnackbar: (state, action: PayloadAction<SnackBar>) => {
            state.snackbarMessages = [...state.snackbarMessages, action.payload];
        },
        closeSnackbar: (state, action: PayloadAction<string>) => {
            state.snackbarMessages = state.snackbarMessages.map((i) =>
                i.id === action.payload ? { ...i, dismissed: true } : { ...i },
            );
        },
        removeSnackbar: (state, action: PayloadAction<string>) => {
            state.snackbarMessages = state.snackbarMessages.filter((i) => i.id !== action.payload);
        },
    },
});

export const appActions = appSlice.actions;
export const appReducer = appSlice.reducer;
